import { render, staticRenderFns } from "./CampaignView.vue?vue&type=template&id=0ddd2e33&"
import script from "./CampaignView.vue?vue&type=script&lang=js&"
export * from "./CampaignView.vue?vue&type=script&lang=js&"
import style0 from "./CampaignView.vue?vue&type=style&index=0&id=0ddd2e33&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports